"use client"

import { useEffect } from "react"
import { toast } from "sonner"

export function PWARegister() {
  useEffect(() => {
    if (typeof window === "undefined") return
    if (!("serviceWorker" in navigator)) return

    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then(registration => {
        // Notify user when a new version is available
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing
          if (!newWorker) return
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              toast.info("New version available — refresh to update.", {
                action: {
                  label: "Refresh",
                  onClick: () => window.location.reload(),
                },
                duration: Infinity,
              })
            }
          })
        })
      })
      .catch(err => {
        console.warn("[PWA] Service worker registration failed:", err)
      })
  }, [])

  return null
}
